import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';
import * as styles from './MapButton.css';

import { IconActionMap16 } from '@cian/ui-kit-design-tokens/icons';

interface IMapButtonProps {
  mapFullUrl: string;
}

export const MapButton: React.FC<IMapButtonProps> = ({ mapFullUrl }) => {
  return (
    <div className={styles['container']}>
      <LinkButton
        href={mapFullUrl}
        target="_blank"
        size="M"
        theme="fill_white_primary"
        beforeIcon={<IconActionMap16 color="icon-main-default" />}
        data-testid="MapLink"
      >
        На карте
      </LinkButton>
    </div>
  );
};
